import axios from 'axios';
import config from '../config';
const apiClient = axios.create({
    baseURL: config.api_url,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});
export default apiClient;
